<template>
  <div class="categoryTabs">
    <v-layout row align-center align-middle class="fullWidth" id="categoryContainer" :class="{'hide-cats': showSearch}">
      <v-flex xs11 class="categoryTabsRow" style="padding-right: 0;">
        <!-- DEV-11334: every category in one tap, so long menus don't need side-scrolling the tabs -->
        <v-btn icon small class="categoryListBtn" :aria-label="$vuetify.t('$vuetify.menu.categories')" @click="showCategoryList = true">
          <v-icon color="primary">list</v-icon>
        </v-btn>
         <!-- v-model="activeTab" -->
        <!-- <v-tabs v-if="menus && menus.length > 1 && activeTab" light color="white" grow slider-color="primary" mandatory ref="tabsRef">
          <v-tab
            v-for="category in menus"
            :key="`catkey_${category.code}`"
            :to="`#${category.anchor}`"
            @click="_scrollIntoView(category)"
            class="snappy-box"
            :class="{ 'activeClass': activeTab == category.anchor }"
            style="margin-right: 5px"
          >
            {{ category.name }}
          </v-tab>
        </v-tabs> -->

        <div id="menuCategories" ref="tabsRef">
          <!-- <v-btn v-for="category in menus"
          flat
            :key="category.code"
            v-ripple
            class="snappy-box clickable"
            :class="{ 'activeClass': activeTab == category.anchor }"
            @click="_scrollIntoView(category)"
          >
            {{ category.name }}
        </v-btn> -->
         <v-tabs
            v-model="activeTab"
            show-arrows
            slider-color="primary"
            background-color="white"
            height="32"
            :class="{ 'scrollable': shouldScroll }"
          >
            <v-tab
              v-for="category in menus"
              :key="category.code"
              :href="`#${category.anchor}`"
              @click="_scrollIntoView(category)"
              class="snappy-tab"
              :class="{ 'activeClass': activeTab == category.anchor }"
            >
              {{ category.name }}
            </v-tab>
          </v-tabs>
        </div>
      </v-flex>

      <v-flex xs1 class="clickable" @click="openSearch" 
        :style="{
            'padding-top': $vuetify.breakpoint.smAndDown ? '7.5px' : '1px',
            'display': 'flex',
            'background-color': 'white',
            'height': '40px !important',
            'padding-left': '0'
          }">
        <v-icon v-if="!showSearch"
          color="primary"
          :medium="$vuetify.breakpoint.smAndDown"
          :large="$vuetify.breakpoint.mdAndUp"
          :style="$vuetify.breakpoint.smAndDown ? 'display: block; float: left; margin-right: 100px' : null"
          style="font-size: 24px !important"
        >
          search
        </v-icon>
      </v-flex>
    </v-layout>

    <span id="searchBar" :class="{'show-search': showSearch}">
      <v-text-field ref="searchBar"
        v-model="searchText"
        @input="searchInput"
        prepend-icon="search"
        append-icon="cancel"
        @click:append="hideSearch"
        label="Search Menu"
        single-line
        style="padding-top: 0px !important; margin-left: 9px !important"
      />
    </span>

    <component :is="$vuetify.breakpoint.xsOnly ? 'v-bottom-sheet' : 'v-dialog'" v-model="showCategoryList" max-width="440" lazy content-class="categoryListDialog">
      <v-card class="categoryListCard" :class="{ sheet: $vuetify.breakpoint.xsOnly }">
        <div v-if="$vuetify.breakpoint.xsOnly" class="categoryListHandle" />
        <div class="categoryListHeader">
          <div class="categoryListTitle">{{ menuName }}</div>
          <div v-if="menuHoursToday" class="categoryListHours">{{ menuHoursToday }}</div>
        </div>
        <div id="categoryList" ref="categoryList">
          <button v-for="category in menus" :key="`list_${category.code}`" type="button" class="categoryListRow"
            :class="{ active: activeTab == category.anchor }" @click="jumpFromList(category)">
            <span class="categoryListName">{{ category.name }}</span>
            <span class="categoryListCount">{{ itemCount(category) }}</span>
          </button>
        </div>
        <div class="categoryListFooter">
          <v-btn block depressed color="primary" class="categoryListClose" @click="showCategoryList = false">
            {{ $vuetify.t('$vuetify.cart.closeModal') }}
          </v-btn>
        </div>
      </v-card>
    </component>

    <v-btn id="jumpToMenuIcon" color="primary" style="border-radius: 9px;" @click="jumpToMenus">
      <v-icon :class="{ 'rotateArrow': showUpArrow }">
        keyboard_arrow_down
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';

import moment from 'moment';
import { isNullOrEmpty, matchTranslation, nowInStoreTz, convertTimeFraction, getStoreHoursMassaged } from '../services/util.service';
import { getTimeRangeForDay } from '../services/schedule.service';

const WEEKDAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']
// Same 'hh:mm A' format as the store hours (getStoreHoursMassaged)
const formatHour = (fraction) => moment({ hour: convertTimeFraction(fraction).hours % 24, minute: convertTimeFraction(fraction).minutes }).format('hh:mm A')

export default {
  props: {
    menus: Array
  },

  data() {
    return {
      activeTab: null,
      lastCheck: 0,

      showSearch: false,
      searchText: null,

      showUpArrow: false,
      showCategoryList: false,
      manualTabSelect: false,
      scrollDebounceTimer: null 
    }
  },

  computed: {
    shouldScroll() {
      if (!this.$refs.tabsRef) return false;
      const tabsContainer = this.$refs.tabsRef;
      const totalTabsWidth = Array.from(tabsContainer.getElementsByClassName('v-tab'))
        .reduce((total, tab) => total + tab.offsetWidth, 0);
      return totalTabsWidth > tabsContainer.offsetWidth;
    },
    menuName() {
      return matchTranslation(get(this.getMenu, 'name.translations')) || 'Menu'
    },
    // Today's hours (store's day, not the guest's): the menu's own schedule (e.g. a Lunch menu),
    // otherwise the store's hours, the same ones the store details show
    menuHoursToday() {
      const day = nowInStoreTz(get(this.getStore, 'timeZone', null) || get(this.getStore, 'timezone', null)).getDay()
      const schedule = get(this.getMenu, 'schedule.items')
      if (!isNullOrEmpty(schedule)) {
        const ranges = getTimeRangeForDay(schedule, WEEKDAYS[day]) || []
        return ranges.map(r => `${formatHour(r.start)} - ${formatHour(r.end)}`).join(', ')
      }
      const store = get(getStoreHoursMassaged(this.getStore || {}), `[${day}]`)
      if (!store || !store.open) return ''
      return store.close ? `${store.open} - ${store.close}` : store.open
    },
    ...mapGetters(['getOrderType', 'getCustomerRewards', 'doesStoreHaveSetting', 'getMenu', 'getStore'])
  },

  methods: {
    async _scrollIntoView(category) {
      this.manualTabSelect = true;

      for (let index in this.menus) {
        if (this.$parent.filteredCategories[index] && !this.$parent.filteredCategories[index].render) {
          this.$set(this.$parent.filteredCategories[index], 'render', true)
          this.$parent.$forceUpdate()
          await this.$nextTick()
        }
        if (this.$parent.filteredCategories[index].anchor == category.anchor)
          break
      }

      this.activeTab = category.anchor;
      await this.$nextTick()
      await new Promise(resolve => requestAnimationFrame(resolve))
      const el = document.getElementById(category.anchor)
      if (el) {
        // DEV-11518: real covered height (store notice + bar), a fixed 64 + 60 hid the first items.
        // 8px gap like deep links -- under the ~17px between sections, so the previous card stays hidden
        const elDistanceToTop = window.pageYOffset + el.getBoundingClientRect().top - this.$parent.stickyScrollOffset() - 8;
        window.scroll({
          top: elDistanceToTop,
          behavior: 'smooth'
        });
      }
    },
    matchTab() {
      const currentHash = this.$route.hash;
      const matchRoute = () => this.menus.find(cat => '#' + cat.anchor === currentHash);
      const matched = matchRoute();
      this.activeTab = (matched || this.menus[0] || {}).anchor;
      if (currentHash && matched) {
        this._scrollIntoView((matched))
      }
    },


    handlePageScroll() {
      if (this.manualTabSelect) {
        clearTimeout(this.scrollDebounceTimer);
        this.scrollDebounceTimer = setTimeout(() => {
          this.manualTabSelect = false;
        }, 150);
        return;
      }
      const _this = this

      const isInViewport = (bound) => {
        /* Check if either the top or bottom is in view taking into
           account header and footer that would cover them */
        /* We can ignore cases where the menu is taking up the whole view port
           because it will have been set as the active menu when it comes into view */
        return bound.top < window.innerHeight || (bound.bottom < window.innerHeight && bound.bottom >= 0);
      }
      const distanceToMiddle = (bound, middle) => {
        // Find the edge of the menu that is closest to the middle of the viewport
        return Math.min(middle - bound.top, bound.bottom - middle)
      }
      const byInView = (menus, middle) => {
        return menus.map(menu => {
                 if (menu && menu.getBoundingClientRect) {
                   const bound = menu.getBoundingClientRect()

                   // Only count menus that are in view
                   if (isInViewport(bound))
                     return {'id': menu.id, 'distance': distanceToMiddle(bound, middle)}
                 }
               }).filter(menu => !!menu)
      }
      const findClosestToMiddle = (menus) => {
        var scrollPosition = window.pageYOffset;
        var windowSize     = window.innerHeight;
        var bodyHeight     = document.body.offsetHeight;

        // If the user has srolled to the bottom of the page, set the last option to active
        if (Math.max(bodyHeight - (scrollPosition + windowSize), 0) < 100)
          return menus[menus.length-1]

        // Find the menu whose top or bottom is the closet to the middle of the screen
        return menus.sort((a,b) => b.distance - a.distance)[0]
      }

      const setClosest = (menuContainers, middle) => {
        const inView = byInView(menuContainers, middle) // Creates a list of all menu titles in the veiwport
        const mostMiddle = findClosestToMiddle(inView)  // Finds the most middle menu title, that's the one we show as active in the titles row
        
        // On scroll, set the active menu to the one that's closet to the middle of the viewport
        const newMenu = !!mostMiddle
          ? (_this.menus.find(menu => menu.anchor == mostMiddle.id) || {}).anchor
          : get(_this.menus, '[0].anchor')

        _this.activeTab = newMenu || _this.activeTab

        // Lazy load menu categories
        for (let curMenu of inView) {
          const index = _this.$parent.filteredCategories.findIndex(menu => menu.anchor == curMenu.id)

          if (this.$parent.filteredCategories[index] && !this.$parent.filteredCategories[index].render) {
            this.$set(this.$parent.filteredCategories[index], 'render', true)
            this.$parent.$forceUpdate()
          }
        }
      }

      // Pointless and caused issues to run the check until the filtered list of menus has been generated
      // The check isn't that expensive but certainly doesn't need to be run as often as this event triggers
      if (!isNullOrEmpty(_this.menus) && (Date.now() - this.lastCheck) > 50) {
        const menuContainers = Object.values(document.getElementsByClassName('menuContainer'))
        const middle = (window.innerHeight || document.documentElement.clientHeight) / 2
        this.lastCheck = Date.now();

        // Once we've scrolled far enough to have the first menu title off screen, flip the arrow as we're moving up
        this.showUpArrow = !isNullOrEmpty(menuContainers) && menuContainers[1].getBoundingClientRect().top < 0

        setClosest(menuContainers, middle)
        // this.$refs.tabsRef ? this.$refs.tabsRef.onResize() : null
      }
    },

    openSearch() {
      this.showSearch = true
      this.$nextTick(() => this.$refs.searchBar.focus())
    },
    hideSearch() {
      this.showSearch = false
      this.searchText = null
      this.$parent.searchText = null
    },
    searchInput($event) {
      this.$parent.searchText = $event

      // Give the store time to update filtered categories and make sure any in view are shown
      setTimeout(this.handlePageScroll, 500)
    },

    jumpToMenus() {
      this._scrollIntoView(this.menus[0])
    },
    // Same items the page renders under each category (StorePage skips entries without a code)
    itemCount(category) {
      return (category.items || []).filter(i => i && 'code' in i).length
    },
    jumpFromList(category) {
      // The dialog's scroll lock only blocks the user, not window.scroll, so jump right away
      this.showCategoryList = false
      this._scrollIntoView(category)
    }
  },

  watch: {
    showCategoryList(open) {
      if (!open) return
      // Long menus: open with the current category in view
      setTimeout(() => {
        const list = this.$refs.categoryList
        const row = list && list.querySelector('.categoryListRow.active')
        if (row) list.scrollTop = row.offsetTop - list.clientHeight / 2 + row.offsetHeight / 2
      }, 50)
    },
    activeTab() {
      this.$nextTick(() => {
        // Always have the active class tab in view
        // v-model also does this but you couldn't side scroll the category row on IOS (it would always scroll back to the active tab)
        const tabWrapper = document.getElementById('menuCategories')

        if (tabWrapper != null) {
          const activeTab = tabWrapper.getElementsByClassName('activeClass')

          if (!isNullOrEmpty(activeTab))
            tabWrapper.scroll({
              left: activeTab[0].offsetLeft,
              behavior: 'smooth'
            })
        }
      })
    },

    getOrderType: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.matchTab()
          }, 75)
        })
      }
    },

    '$vuetify.lang.current'() {
      this.hideSearch()
    }
  },

  mounted() {
    // We wait before grabbing menuContainers to let them render
    setTimeout(() => {
      try {
        // Set the default selected menu title
        this.handlePageScroll()
      } finally {
        // On scroll, check which menu title is now in view
        window.addEventListener('scroll', this.handlePageScroll, false);
      }
    }, 1000)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handlePageScroll)
  }
}
</script>
<style>
  .categoryTabsRow {
    display: flex;
    align-items: center;
  }

  /* Lined up with the "Menu" title (18px) */
  .categoryTabs .categoryListBtn {
    flex: 0 0 auto;
    margin: 0 8px 0 16px;
  }

  /* show-arrows reserves 40px on the left for the prev arrow even while it's hidden, which left a
     gap after the list button (the `.categoryTabs >>> .v-tabs__wrapper` margin fix below never
     applies: >>> only works in scoped styles). Start the tabs right after the button and let the
     prev arrow, once you've scrolled, sit over them on white instead. */
  #menuCategories .v-tabs__wrapper--show-arrows {
    margin-left: 0;
  }
  #menuCategories .v-tabs__icon--prev {
    left: 0;
    z-index: 1;
    justify-content: center;
    background-color: white;
  }

  /* DEV-11334 category list */
  .categoryListDialog {
    border-radius: 20px !important;
    overflow: hidden;
  }
  .categoryListCard {
    border-radius: inherit !important;
  }
  /* Phones: Vuetify 1.5's bottom sheet ignores content-class, so round the card itself */
  .categoryListCard.sheet {
    border-radius: 20px 20px 0 0 !important;
    padding-top: 10px;
  }
  .categoryListHandle {
    width: 40px;
    height: 4px;
    margin: 0 auto;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.15);
  }
  .categoryListHeader {
    text-align: center;
    padding: 18px 24px 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .categoryListTitle {
    font-size: 20px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.87);
  }
  .categoryListHours {
    margin-top: 2px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
  #categoryList {
    max-height: 60vh;
    overflow-y: auto;
    padding: 8px 12px;
  }
  .categoryListRow {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 14px 16px;
    border-radius: 8px;
    font-size: 16px;
    text-align: left;
    color: rgba(0, 0, 0, 0.75);
    overflow: hidden;
  }
  /* mouse only: on phones a tap would leave the hover tint behind */
  @media (hover: hover) {
    .categoryListRow:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
  .categoryListRow.active {
    color: var(--v-primary-base);
    font-weight: 700;
  }
  /* Tinted background + left bar in the store's primary colour */
  .categoryListRow.active::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: var(--v-primary-base);
    opacity: 0.08;
    pointer-events: none;
  }
  .categoryListRow.active::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: var(--v-primary-base);
  }
  .categoryListName {
    flex: 1;
    min-width: 0;
    word-break: break-word;
  }
  .categoryListCount {
    flex: 0 0 auto;
    margin-left: 16px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.55);
  }
  .categoryListFooter {
    padding: 14px 20px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
  .categoryListClose.v-btn {
    margin: 0;
    height: 48px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 700;
    text-transform: none;
  }

  #menuCategories {
    flex: 1;
    min-width: 0;
    width: 100%;
    position: relative;
    background: white;
    white-space: nowrap;
    scrollbar-width: none; 
    -ms-overflow-style: none;
    overflow: auto;
  }

  #menuCategories::-webkit-scrollbar {
    display: none;
  }

  .categoryTabs {
    height: 40px;
    overflow: hidden;
    position: relative;
    padding-bottom: 5px;
    background-color: white;
    border-bottom: none;
  }

  .categoryTabs .activeClass {
    background-color: var(--v-primary-base);
    color: white !important;
  }

  .categoryTabs >>> .v-tab {
    min-width: 96px !important;
    padding: 8px 16px !important;
    font-size: var(--text-size-1) !important;
    font-weight: 500 !important;
    text-transform: none !important;
    letter-spacing: 0.5px !important;
    border-radius: 4px !important;
    margin: 4px !important;
    height: auto !important; 
    min-height: 32px !important; 
    line-height: 1.2 !important;
    white-space: normal !important; 
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.3s ease;
    opacity: 0.87;
  }

  .categoryTabs >>> .v-tab.activeClass {
    background-color: var(--v-primary-base) !important;
    background: var(--v-primary-base) !important;
    color: white !important;
  }

  .categoryTabs >>> .v-tab:not(.activeClass):hover {
    background-color: rgba(200, 200, 200, 0.85) !important;
  }

  .categoryTabs >>> .v-tabs__wrapper {
    transform: none !important;
    width: auto !important;
    display: flex !important;
    justify-content: flex-start !important;
    scrollbar-width: none;
    -ms-overflow-style: none;
    height: auto !important;
    min-height: 32px !important;
    margin-left: 0 !important; 
  }

  .categoryTabs >>> .v-tabs__div {
    justify-content: flex-start !important;
  }

  .categoryTabs >>> .v-tabs__container {
    height: auto !important;
    min-height: 32px !important;
    justify-content: flex-start !important;
    transform: none !important;
    margin-left: 0 !important;
  }

  #categoryContainer {
    align-items: center;
    transition: opacity 0.2s ease, visibility 0.2s;
  }

  /* DEV-11334: tabs and category list button fade out while searching; visibility keeps the row height so the menu doesn't jump */
  #categoryContainer.hide-cats {
    opacity: 0;
    visibility: hidden;
  }

  .categoryTabs #searchBar {
    display: inline-flex;
    align-items: center;
    position: absolute;
    right: 10px;
    top: 4px;
    margin-bottom: 4px;
    margin-top: -4px !important;
    width: calc(100% - 20px);
    background: white;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transform: translateX(16px);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  }

  #searchBar.show-search {
    opacity: 1;
    visibility: visible;
    transform: none;
  }

  #jumpToMenuIcon {
    position: fixed;
    bottom: 10px;
    right: 10px;
    height: 36px !important;
    width: 36px !important;
    min-width: 24px !important;
  }

  #jumpToMenuIcon .v-icon {
    transition: all 1s ease-in-out;
  }

  .rotateArrow {
    transform: rotate(180deg);
  }

  .snappy-tab {
    max-width: unset !important;
  }

  @media only screen and (max-width: 920px) {
    .categoryTabs {
      padding-top: 0px;
    }

    .categoryTabs >>> .v-tab {
      min-width: 72px !important;
      padding: 6px 12px !important;
      font-size: calc(var(--text-size-1) * 0.9) !important;
    }
  }
</style>
